import { atom } from "recoil"

export const reservedRequestIdState = atom({
  key: "atoms/contact/reservedRequestIdState",
  default: 0,
})
